import TokenService from '@/helpers/token';
import { IAuthState } from './auth';

const authState: IAuthState = {
    loginSuccess: !!TokenService.getToken(),
    typeIdentity: 'passport',
    userRegistered: {},
    userLogined: {},
    step1: {},
    step2: {},
    step3: {},
    typeDefault: '',
    setNotifySuccess: ''
};
export default authState;
